import { Service, ServicesProperty } from '@onlog-public/additional-services-types';
import { AdditionServicesOptionsState } from '@pages/AdditionalServices/containers/additionServicesOptionsContext';
import {
  AServiceCache,
  AServicePropertyCache,
  AServicePropertyFilterAndOrder,
  AdditionServicesState,
} from '@pages/AdditionalServices/containers/types';

import { ServiceData, SetUpServiceData } from '../../../basket/types';
import { serviceRestoreStateGeneratorProcessor } from '../types';

/**
 * VariantPropertiesProcessor формирует свойства вариантов
 */
export class VariantPropertiesProcessor implements serviceRestoreStateGeneratorProcessor {
  /**
   * restore выполняет восстановление стейтов. Возвращает все стейты.
   * @param _
   * @param __
   * @param additionalServiceState
   * @param optionsState
   * @param serviceCacheState
   * @param servicePropertyCacheState
   * @param servicePropertyFilterAndOrderState
   */
  async restore(
    _: SetUpServiceData,
    __: (SetUpServiceData | ServiceData)[],
    additionalServiceState: AdditionServicesState,
    optionsState: AdditionServicesOptionsState,
    serviceCacheState: AServiceCache,
    servicePropertyCacheState: AServicePropertyCache,
    servicePropertyFilterAndOrderState: AServicePropertyFilterAndOrder
  ) {
    const properties: { [T in string]: ServicesProperty[] } = {};
    const servicesByDir: { directoryID: string; services: Service[] }[] = [];

    if (additionalServiceState.LastServiceInPath.is_variants) {
      additionalServiceState.Variants.map((variant) => {
        properties[variant.id] = [...variant.properties];
      });
    }

    Object.entries(additionalServiceState.VariantServices).forEach(([dirId, services]) => {
      servicesByDir.push({ directoryID: dirId, services });
    });

    servicesByDir.map((r) => {
      properties[r.directoryID] = properties[r.directoryID] ?? [];
    });

    return {
      isValid: true,
      additionalServiceState: {
        ...additionalServiceState,
        VariantProperties: properties,
      },
      optionsState,
      serviceCacheState,
      servicePropertyCacheState,
      servicePropertyFilterAndOrderState,
    };
  }
}
